module.exports = __webpack_public_path__ + "img/2024_02.8dc76fd3.jpg";